import './add-field.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import SelectField from '../../../../shared/form-elements/select/field';

const AddAffiliateForm = reduxForm({
	form: 'childAffiliatesAddAffiliateForm'
})(props => (
	<div>
		<Field
			name="affiliate"
			placeholder="Add affiliate"
			component={SelectField}
			multi={false}
			onChange={affiliate => {
				props.addAffiliate(affiliate[0]);
			}}
			options={props.affiliatesLookups}
		/>
	</div>
));

const propTypes = {
	intl: PropTypes.func,
	onClick: PropTypes.func,
	addAffiliate: PropTypes.func,
	affiliatesLookups: PropTypes.func,
	shouldShowAddAffiliateSelect: PropTypes.bool
};

const AddField = ({ intl, onClick, shouldShowAddAffiliateSelect, addAffiliate, affiliatesLookups }) =>
	shouldShowAddAffiliateSelect ? (
		<AddAffiliateForm addAffiliate={addAffiliate} affiliatesLookups={affiliatesLookups} />
	) : (
		<div className="add-entity" onClick={onClick}>
			<span className="title">{intl('Add affiliate')}</span>
		</div>
	);

AddField.propTypes = propTypes;

export default AddField;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/affiliates/add-field.js